import axios from 'axios'
import { User } from 'firebase/auth'

import { SpecialLocationsForm } from './types'

export const postNewSpecialLocations = async (
	userAuth: User,
	specialLocationsForm: SpecialLocationsForm[]
) => {
	try {
		const cleanedLocations = cleanSpecialLocationsNames(specialLocationsForm)
		await axios.post<{ message: string; quantity: number }>(
			`${process.env.REACT_APP_API_URL}/special-locations`,
			cleanedLocations,
			{
				headers: {
					Authorization: await userAuth.getIdToken(),
				},
			}
		)
		return true
	} catch (error: any) {
		console.error('❌ Error adding new exclusion:', error.message)
		throw error
	}
}

const cleanSpecialLocationsNames = (
	specialLocations: SpecialLocationsForm[]
): SpecialLocationsForm[] => {
	return specialLocations.map(location => ({
		...location,
		names: location.names.filter(name => !!name.trim().match(/[a-zA-Z0-9]/)),
	}))
}
